import { ERROR_TYPE } from '../models/error-type';

export const config = {
	default_type: ERROR_TYPE.BLOCK
};
